import React, { useContext } from "react";

import {TranslationsContext} from "@proxy/_contexts";

export default function OverlayMiddleRecord() {
  const translations = useContext(TranslationsContext);

  return (
    <div className={"gc__record_button_message_container"} >
      <div className={"gc__record_button_message"}>
        <p>{ translations.video_recorder_record_message }</p>
      </div>
    </div>
  );
}
